module.exports = __webpack_public_path__ + "images/sgp/SizeGuide/10x30.svg";